// Container da page de Templates do notification-center.
import { PlusIcon } from "lucide-react"
import { Suspense, useState } from "react"
import { useTranslation } from "react-i18next"

import { Button } from "@/components/ui/button"
import { useAuth } from "@/contexts/auth"

import { TemplateCreateDialog } from "./template-create-dialog"
import { TemplateFilters } from "./template-filters"
import { TemplatesTable } from "./templates-table"

export const NotificationCenterTemplates = () => {
  const { t } = useTranslation()
  const { selectedWhiteLabel } = useAuth()
  const [isCreateDialogOpen, setIsCreateDialogOpen] =
    useState(false)

  return (
    <div className="space-y-4 @container">
      <header className="flex flex-wrap items-start justify-between gap-2">
        <div className="flex flex-col gap-1">
          <h1 className="text-2xl font-bold tracking-tight">
            {t(
              "pages.notificationCenter.templatesPage.title"
            )}
          </h1>
          <p className="text-sm text-muted-foreground">
            {t(
              "pages.notificationCenter.templatesPage.subtitle"
            )}
          </p>
        </div>
        {/* Novo template abre o dialog de criação (POST /templates
            → uuid real → editor já na v1 DRAFT). */}
        <Button
          type="button"
          className="btn-whitelabel"
          onClick={() => setIsCreateDialogOpen(true)}
        >
          <PlusIcon
            className="mr-2 size-4"
            aria-hidden="true"
          />
          {t(
            "pages.notificationCenter.templatesPage.newTemplate"
          )}
        </Button>
      </header>
      <Suspense>
        <TemplateFilters />
        <TemplatesTable />
      </Suspense>
      {/* Form de novo template (renderizado só quando aberto). */}
      {isCreateDialogOpen && (
        <TemplateCreateDialog
          defaultWhiteLabelId={selectedWhiteLabel?.uuid}
          onClose={() => setIsCreateDialogOpen(false)}
        />
      )}
    </div>
  )
}
